var $d0808f7b535fb9b6$exports = {};
$d0808f7b535fb9b6$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `La date s\xe9lectionn\xe9e est indisponible`,
            other: `Les dates s\xe9lectionn\xe9es sont indisponibles`
        })}.`
};


export {$d0808f7b535fb9b6$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
